module.exports = __webpack_public_path__ + "136f23786c20e103b872f61e599e6ae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Stanners.jpg
// module id = potb
// module chunks = 0